import Swal from "sweetalert2";
import { defaultBackgroundColor } from "../lib/constants/values/Values";

export const showAlert = (
  title: string,
  text: string,
  icon: "success" | "error" | "warning" | "info" = "error",
  confirmButtonColor?: any,
  background?: string,
  color?: string,
  callback?: () => void
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
    customClass: {
      confirmButton: "bg-red-600 text-white rounded text-sm ",
    },
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });
};

export const successAlert = (
  title: string,
  text: string,
  icon: "success",
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
    customClass: {
      confirmButton:
        "bg-red-600 text-white rounded  hover:shadow-red-500/40 text-sm ",
    },
  });
};

export const confirmationMsg = (
  title: string,
  text?: string,
  background?: string,
  color?: string,
  confirmButtonColor?: any
) => {
  return new Promise<boolean>((resolve) => {
    Swal.fire({
      title: title,
      text: text,
      icon: "question",
      iconHtml: "?",
      confirmButtonText: "Confirm",
      confirmButtonColor: confirmButtonColor
        ? confirmButtonColor
        : defaultBackgroundColor,
      cancelButtonText: "Cancel",
      showCancelButton: true,
      showCloseButton: true,
      allowOutsideClick: false,
      background: background, // Set background color
      color: color, // Set text color
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });
};

export const selectCurrencyPartnersMsg = (
  icon: "success" | "error" | "warning" | "info" = "error",
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: "Select Currency and Partner",
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
  });
};

const alertMsg = (
  icon: "success" | "error" | "warning" | "info" = "error",
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: "Error Uploading File",
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
  });
};

export const showAlertSessionInfo = (
  title: string,
  text: string,
  icon: "success" | "error" | "warning" | "info" = "error",
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
    customClass: {
      confirmButton: "bg-red-600 text-white rounded  text-sm ",
    },
  });
};

export const generateLoading = (
  title: string,
  background?: string,
  color?: string
) => {
  Swal.fire({
    title: title,
    showCancelButton: false,
    showConfirmButton: false,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
  });
  Swal.showLoading();
};

export const stopLoading = () => {
  Swal.close();
};

export const showConnectionError = (
  title: string,
  text: string,
  icon: "success" | "error" | "warning" | "info" = "error",
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: title,
    html: `Try after a few minutes. If the problem persists, please contact the Helpdesk at tg.helpdesk@mlhuillier.com. Thank you. <span class="font-bold">${text}</span>`,
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    allowOutsideClick: false,
    background: background, // Set background color
    color: color, // Set text color
  });
};

export const SomethingAlert = (
  title: string,
  text: string,
  icon: "success" | "error",
  refNo: string,
  background?: string,
  confirmButtonColor?: any,
  color?: string
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "OK",
    confirmButtonColor: confirmButtonColor
      ? confirmButtonColor
      : defaultBackgroundColor,
    background: background, // Set background color
    color: color, // Set text color
    customClass: {
      confirmButton: "bg-red-600 text-white rounded text-sm",
    },
    html: `
      <div style="text-align: center;">
       <div style="margin-bottom: 10px;">${text}</div>
        <div style="margin-top: 20px; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
          <span style="font-weight: bold; color: black;">BATCH NO : </span> 
          <span style="color: red;"> ${refNo} </span>
        </div>
      </div>
    `,
    showCloseButton: true, // Optional: Show a close button
    backdrop: true, // Optional: Backdrop settings
    allowOutsideClick: false,
  });
};
export { alertMsg };
